<template>
   <div class="flex align-center padding-tb-sm devider">
    <span class="text-gray text-sm margin-right" style="min-width: 96px;" v-if="name">{{ name }}</span>
    <slot name="name" v-else></slot>
    <div class="flex1">
      <slot></slot>
    </div>
   </div>
</template>
<script setup lang="ts">
import {defineProps} from 'vue'
    const props=defineProps({
      name:String
    })
</script>
